import { useSyncExternalStore } from "react";

/** Minimal pushState router. The app has few top-level routes; views inside the
 *  mailbox are app state, not URLs, so there's no need for a routing library. */
const subscribe = (cb: () => void) => {
  window.addEventListener("popstate", cb);
  return () => window.removeEventListener("popstate", cb);
};
export const usePath = () => useSyncExternalStore(subscribe, () => location.pathname);
export function navigate(to: string) {
  history.pushState(null, "", to);
  dispatchEvent(new PopStateEvent("popstate"));
}
